import JsonApi from "../../api/jsonApi";
import {Feature} from "../../interfaces/Feature";
import {AxiosResponse} from "axios";
import {Dispatch} from "redux";
import {RootState} from "../../interfaces/Global";
import {CartItem} from "../../interfaces/CartItem";

let _pricingGrid: PricingGridPreset = {
  columnHeaders: [], priceTable: [], rowHeaders: [], settings: {
    currency: "USD", mode: "RetailPrice", visualizerType: "", version: 1,
  },
};

export const getFeaturesPriceTable = () => {
  return async (dispatch: Dispatch, getState: () => RootState): Promise<any> => {
    if (!getState().fabricatorState.settings.enablePriceGrid) {
      return
    }
    return JsonApi.getFeaturesPriceTable()
      .then((response: AxiosResponse) => {
        if (!response || !Array.isArray(response.data) || !response.data[0] || !response.data[0].priceTable) {
          return
        }
        _pricingGrid = response.data[0];
        if (_pricingGrid?.rowHeaders) {
          _pricingGrid.rowHeaders = _pricingGrid.rowHeaders.map(header => {
            header.featuresRequired = header.featureData.filter(f => f.isRequired);
            return header
          });
        }
        if (_pricingGrid?.columnHeaders) {
          _pricingGrid.columnHeaders = _pricingGrid.columnHeaders.map(header => {
            header.featuresRequired = header.featureData.filter(f => f.isRequired);
            return header
          });
        }
        console.log("getFeaturesPriceTable _pricingGrid", _pricingGrid);
        // dispatch(restorePaymentInfo(Misc.parseShippingAndBillingResponse({
        //   shippingAddress: response.data,
        // })))
      })
      .catch(error => error)
  }
}

const pricingGridHeaderHasAddedCardItem = (header: PricingGridHeader, storeState: RootState, forQuoteIndex?: number|undefined) => {
  const activeQuoteIndex = Number.isInteger(forQuoteIndex) ? forQuoteIndex : storeState.quotesState.activeQuoteIndex;
  const currentRoomCartItems = storeState.cartState.cartItems.filter(cartItem => {
    return cartItem.currentQuote === activeQuoteIndex
  })
  const cartSharedNames = new Set(
    currentRoomCartItems.map(
      (cartItem: CartItem) => cartItem.cartFeature.dbFeature.sharedFeatureName
    )
  )
  if (header.featuresRequired.length > 0) {
    return header.featuresRequired.every((f) => cartSharedNames.has(f.sharedFeatureName))
  }
  return header.featureData.some((f) => cartSharedNames.has(f.sharedFeatureName))
}

export const getPricingGridFeaturePrice = (feature: Feature, storeState: RootState, forQuoteIndex?: number|undefined): number | null => {
  if (!storeState.cartState.cartItems.length) {
    return null;
  }
  const existingRecords: PricingGridTableItem[] = _pricingGrid.priceTable.filter(record => {
    return record.sku === feature.dbFeature.sku
  })
  let newPrice: number | null = null;
  let priceWasSetFrom = "";
  if (!existingRecords.length) {
    return null
  }
  existingRecords.forEach((existingRecord: PricingGridTableItem) => {
    if (priceWasSetFrom) {
      return
    }
    existingRecord.tableData.forEach((tableRow: PricingGridTableItemData) => {
      if (priceWasSetFrom) {
        return
      }
      const columnHeader = _pricingGrid.columnHeaders.find((header: PricingGridHeader) => {
        return header.id === tableRow.columnId;
      });
      const rowHeader = _pricingGrid.rowHeaders.find((header: PricingGridHeader) => {
        return header.id === tableRow.rowId;
      });
      if (!columnHeader || !rowHeader) {
        return null
      }
      if (!pricingGridHeaderHasAddedCardItem(columnHeader, storeState, forQuoteIndex)) {
        return null
      }
      if (!pricingGridHeaderHasAddedCardItem(rowHeader, storeState, forQuoteIndex)) {
        return null
      }
      priceWasSetFrom = columnHeader.id + " " + rowHeader.id;
      newPrice = tableRow.price;
    })
  })
  return newPrice;
};
